import _regeneratorRuntime from "D:\\new-code\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CourseSoldOutTip from "@/modules/stu/components/CourseSoldOutTip.vue";
import CoursePeriodsType from "@/modules/stu/components/CoursePeriodsType";
import CourseContentTip from "@/modules/stu/components/CourseContentTip";
import FileList from "@/modules/stu/components/FileList";
export default {
  name: "MemberClassesPeriod",
  components: {
    CourseSoldOutTip: CourseSoldOutTip,
    CoursePeriodsType: CoursePeriodsType,
    CourseContentTip: CourseContentTip,
    FileList: FileList
  },
  props: {
    course: {
      type: Object,
      default: function _default() {}
    },
    period: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      showSoldOut: false,
      showContentDialog: false,
      chapter_content: ""
    };
  },
  computed: {
    playDisable: function playDisable() {
      if (this.course.course_type == 7 || this.course.course_type == 10) {
        return false;
      }

      return this.period.play_type > 2 && this.period.play_type != 4;
    }
  },
  methods: {
    //处理课时课件文件
    getFile: function getFile(data) {
      if (data && data.length > 0) {
        return data.map(function (item) {
          return _objectSpread({}, item, {
            ware_filename: item.file_name
          });
        });
      }

      return [];
    },
    onPeriodPlay: function () {
      var _onPeriodPlay = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(this.period);

                if (this.period.periods_type == 7 || this.period.periods_type == 10 || this.playDisable) {
                  if (this.period.periods_type == 7) {
                    this.showContentDialog = true;
                    this.chapter_content = this.period.content;
                  }
                }

                if (!(this.course.status == 2 && this.course.is_go_to_study == 0)) {
                  _context.next = 5;
                  break;
                }

                this.showSoldOut = true;
                return _context.abrupt("return");

              case 5:
                if (this.$services.CourseService.checkLiveState(this.course_type, this.period)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                _context.next = 9;
                return this.$services.CourseService.checkLimit(this.course.course_basis_id);

              case 9:
                _context.next = 11;
                return this.$services.CourseService.watchVideo(this.period, this.period.periods_type, this.course.course_basis_id);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onPeriodPlay() {
        return _onPeriodPlay.apply(this, arguments);
      }

      return onPeriodPlay;
    }(),
    onLeave: function onLeave() {
      this.$emit("leave");
    }
  }
};